var render = function render(){var _vm=this,_c=_vm._self._c;return _c('va-edit-layout',{attrs:{"title":_vm.title},scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('va-create-button')]},proxy:true}])},[_c('keywords-form',{attrs:{"id":_vm.id,"title":_vm.title,"item":_vm.item}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }